import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import './Press.css';
import forbes from '../../img/press/forbes-logo.png';
import scotchwhisky from '../../img/press/scotch-whisky.png';

class Press extends Component {
  render() {
    return (
      <div className="press">
        <Row>
          <Col md={12} >
            <h2>They talk about us:</h2>
          </Col>
        </Row>

        <Row className="press-wrapper">
          <Col className="featured-wrapper" s={6} xs={12} md={4}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.forbes.com/sites/felipeschrieberg/2019/03/29/ailsa-bay-releases-blockchain-protected-scotch-whisky/#2619c151dca4"
            >
              <div className="post-content">
                <img src={forbes} alt="Forbes about Distilled ID by arc-net" />
                <p>
                  Teaming up with blockchain technology company arc-net, William Grant’s Ailsa Bay
                  travel retail whisky uses blockchain ledgers that allow customers to track the
                  whisky ‘from source to store’. (...)
                </p>
              </div>
            </a>
          </Col>

          <Col className="featured-wrapper" s={6} xs={12} md={4}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://scotchwhisky.com/magazine/latest-news/25066/ailsa-bay-traces-whisky-with-blockchain-tech/"
            >
              <div className="post-content">
                <img src={scotchwhisky} alt="Ailsa Bay powered by arc-net's blockchain based technology" />
                <p>
                  (...) The distillery, which is owned by William Grant & Sons, partnered with
                  specialist blockchain technology company arc-net to allow customers to track the
                  expression from ‘source to store’.
                </p>
              </div>
            </a>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/components/common/Press.js